import { useState, useEffect } from "react";
import { Dropdown, Button } from "antd";
import ProductModal from "./ProductModal";
import Products from "./Products.jsx";
import PROPERTIES from "../../Config/properties";
import CONSTANTS from "../../Constants/static";
import productList from "../../Constants/productList";
import getUserDetails from "../../Helpers/getUserDetails";
import deleteCookie from "../../Helpers/deleteCookie";
import imagesUrls from "../../Constants/imagesUrls";
import "./Navbar.css";
import "./ProductModal.css";

function Navbar() {
  const [productMenuVisible, setProductMenuVisible] = useState(false);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [productState, setProductState] = useState(false);
  const [calculator, setCalculator] = useState(false);
  const [tools, setTools] = useState(false);
  const [updates, setUpdates] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    const userData = getUserDetails();
    setUserDetails(userData);
  }, []);

  const subMenu = (menu) => {
    return menu.map((item, index) => {
      return (
        <li key={index}>
          <a href={item.mobile_url} target="_blank" rel="noreferrer">
            <span className="icon_ig">
              <img src={item.img_url} alt={item.name}></img>
            </span>
            {item.name}
          </a>
        </li>
      );
    });
  };

  const logoutMenu = [
    {
      key: "1",
      label: (
        <Button
          onClick={handleLogout}
          className="logout-icon-nav logout-text my-1"
        >
          <img
            src={imagesUrls.logout_icon}
            alt="Logout"
            className="mr-2 logout-image"
          />
          Logout
        </Button>
      ),
    },
  ];

  function handleSignIn() {
    let signinUrl = PROPERTIES.login_url;
    if (window.location.pathname && window.location.pathname.length > 1) {
      signinUrl = `${PROPERTIES.login_url}${window.location.pathname}?utm_source=Direct-Traffic&utm_medium=MA_VerifiedPnL`;
    }
    window.location.href = signinUrl;
  }

  function handleLogout() {
    deleteCookie("_FYERS");
    setUserDetails({});
  }

  return (
    <>
      <header className="border-bottom-light bg-white sticky-top navbar-light">
        <div className="container-fluid py-md-0 py-3">
          <div className="navbar navbar-expand-lg justify-content-between p-0">
            <span className="navbar-brand mr-0 mr-md-2">
              <img src={imagesUrls.fyers_logo} height="40" alt="Fyers Logo" />
            </span>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="" onClick={() => setMobileMenuVisible(true)}>
              <img
                src={imagesUrls.hamburger_menu}
                width="25"
                alt="Open Menu"
                className="mb-1 mr-2 logout-icon"
              />{" "}
            </div>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mr-auto ml-5 pl-5">
                <li className="nav-item py-1 px-2">
                  <a
                    href="https://fyers.in/about/"
                    target="_blank"
                    rel="noreferrer"
                    className="nav-link py-4"
                  >
                    WHO WE ARE?
                  </a>
                </li>
                <li className="nav-item py-1 px-2 p-dropdown">
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: "1",
                          label: <Products />,
                        },
                      ],
                    }}
                    placement="bottom"
                    arrow
                    trigger={["hover"]}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    <span className="nav-link py-4 cursor-pointer">
                      PRODUCTS
                      <img
                        alt=""
                        className="nav-arrow-rotate1"
                        src={imagesUrls.down_arrow_icon}
                      />
                    </span>
                  </Dropdown>
                </li>
                <li className="nav-item py-1 px-2">
                  <a
                    href="https://fyers.in/pricing/"
                    target="_blank"
                    rel="noreferrer"
                    className="nav-link py-4"
                  >
                    PRICING
                  </a>
                </li>
                <li className="nav-item py-1 px-2">
                  <a
                    href="https://fyers.in/community/"
                    target="_blank"
                    rel="noreferrer"
                    className="nav-link py-4"
                  >
                    COMMUNITY
                  </a>
                </li>
                <li className="nav-item py-1 px-2">
                  <a
                    href="https://support.fyers.in"
                    target="_blank"
                    rel="noreferrer"
                    className="nav-link py-4"
                  >
                    SUPPORT
                  </a>
                </li>
              </ul>
              {userDetails.loggedIn ? (
                <ul className="navbar-nav ml-md-auto d-md-flex">
                  <li className="navbar-user-text logout-style">
                    <Dropdown
                      placement="bottom"
                      arrow
                      menu={{ items: logoutMenu }}
                      trigger={["hover"]}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      <span
                        className="nav-item nav-link dropdown-toggle"
                        id="bd-versions"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <img
                          src={imagesUrls.user_icon}
                          width="28"
                          alt="User profile"
                          className="mb-1 mr-2"
                        />
                        &nbsp;<span>{userDetails.fy_id} </span>
                        &nbsp;
                        <span className="drp_btn">
                          <img
                            alt="logout"
                            className="nav-arrow-rotate2 logout-icon-nav"
                            src={imagesUrls.down_arrow_icon}
                          />
                        </span>
                      </span>
                    </Dropdown>
                  </li>{" "}
                </ul>
              ) : (
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item mr-2">
                    <span
                      className="nav-link sign-in-button"
                      onClick={handleSignIn}
                    >
                      SIGN IN
                    </span>
                  </li>
                  <li className="nav-item mr-2 ">
                    <a
                      className="btn btn-primary nav-link text-white sign-up-button"
                      href={CONSTANTS.sign_up_url}
                    >
                      Sign Up Now
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div
              className="productMenu"
              onClick={() => setProductMenuVisible(true)}
            >
              <img
                src={imagesUrls.grid_menu_icon}
                width="25"
                alt="Grid"
                className="mb-1 mr-2"
              />{" "}
            </div>
          </div>
          {mobileMenuVisible && (
            <div className="mobile_menu">
              <div className="d-flex justify-content-between user-info-container">
                {userDetails.loggedIn && (
                  <li className="font-weight-bold d-flex align-items-center">
                    <img
                      src={imagesUrls.user_icon}
                      width="25"
                      alt="User"
                      className="mr-2"
                    />{" "}
                    {userDetails.fy_id}
                  </li>
                )}

                <div
                  className="ml-auto"
                  onClick={() => setMobileMenuVisible(false)}
                >
                  <img
                    src={imagesUrls.close_menu_icon}
                    width="25"
                    alt="Close Menu"
                    className="mb-1 logout-icon"
                  />{" "}
                </div>
              </div>
              <ul className="menu">
                <li>
                  <a
                    href="https://fyers.in/about"
                    target="_blank"
                    rel="noreferrer"
                  >
                    WHO WE ARE?
                  </a>
                </li>
                <li>
                  <span
                    className="drop-btn navbar-dropdown-item"
                    onClick={() => setProductState(!productState)}
                  >
                    PRODUCTS
                    <span
                      className={
                        productState ? "nav-arrow-rotate drp_btn" : "drp_btn"
                      }
                    >
                      <img alt="down arrow" src={imagesUrls.down_arrow_icon} />
                    </span>
                  </span>
                  {productState ? (
                    <div className="sub_menu">
                      <ul>{subMenu(productList["Products"])}</ul>
                    </div>
                  ) : (
                    ""
                  )}
                </li>
                <li>
                  <a
                    href="https://fyers.in/pricing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    PRICING
                  </a>
                </li>
                <li>
                  <a
                    href="https://fyers.in/community"
                    target="_blank"
                    rel="noreferrer"
                  >
                    COMMUNITY
                  </a>
                </li>
                <li>
                  <a
                    href="https://support.fyers.in"
                    target="_blank"
                    rel="noreferrer"
                  >
                    SUPPORT
                  </a>
                </li>
                <li>
                  <span
                    className="drop-btn navbar-dropdown-item"
                    onClick={() => setTools(!tools)}
                  >
                    TOOLS
                    <span
                      className={tools ? "nav-arrow-rotate drp_btn" : "drp_btn"}
                    >
                      <img alt="down arrow" src={imagesUrls.down_arrow_icon} />
                    </span>
                  </span>
                  {tools ? (
                    <div className="sub_menu">
                      <ul>{subMenu(productList["Tools"])}</ul>
                    </div>
                  ) : (
                    ""
                  )}
                </li>
                <li>
                  <span
                    className="drop-btn navbar-dropdown-item"
                    onClick={() => setCalculator(!calculator)}
                  >
                    CALCULATORS
                    <span
                      className={
                        calculator ? "nav-arrow-rotate drp_btn" : "drp_btn"
                      }
                    >
                      <img alt="down arrow" src={imagesUrls.down_arrow_icon} />
                    </span>
                  </span>
                  {calculator ? (
                    <div className="sub_menu">
                      <ul>{subMenu(productList["Calculator"])}</ul>
                    </div>
                  ) : (
                    ""
                  )}
                </li>
                <li>
                  <span
                    className="drop-btn navbar-dropdown-item"
                    onClick={() => setUpdates(!updates)}
                  >
                    UPDATES
                    <span
                      className={
                        updates ? "nav-arrow-rotate drp_btn" : "drp_btn"
                      }
                    >
                      <img alt="down arrow" src={imagesUrls.down_arrow_icon} />
                    </span>
                  </span>
                  {updates ? (
                    <div className="sub_menu">
                      <ul>{subMenu(productList["Updates"])}</ul>
                    </div>
                  ) : (
                    ""
                  )}
                </li>
                {!userDetails.loggedIn && (
                  <li>
                    <span className="signin-mobie-btn" onClick={handleSignIn}>
                      SIGN IN
                    </span>
                  </li>
                )}
              </ul>
              {userDetails.loggedIn ? (
                <div className="sign_btn">
                  <button className="btn w-100" onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              ) : (
                <div className="sign_btn">
                  <a href={CONSTANTS.sign_up_url} className="btn">
                    Sign Up Now
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
        {productMenuVisible && (
          <div className="product_menu">
            <ProductModal
              setProductMenuOpen={setProductMenuVisible}
              setMobileMenuVisible={setMobileMenuVisible}
            />
          </div>
        )}
      </header>
    </>
  );
}

export default Navbar;
